import {getDateUtilDefaultInstance} from '/util/date.util';

const MONTH_COUNT = 6;

/**
 * @returns {Array<{startDate: dateFns, endDate: dateFns}>} Returns an array of start and end dates for the last 6 months
 */
export const getDateArray = () => {
  const dateUtil = getDateUtilDefaultInstance();
  const date = dateUtil.getNow();

  let dateArray = [];

  for (let i = 1; i <= MONTH_COUNT; i++) {
    const startDate = new Date(date.getFullYear(), date.getMonth() - i, 1);
    const endDate = new Date(date.getFullYear(), date.getMonth() - i + 1, 0);
    dateArray.push({startDate, endDate});
  }

  return dateArray;
};

/**
 * @param {array} dateArray - Array of object {startDate, endDate}
 * @param {string} startDateFormat - Description of how the start date should be formed
 * @param {string} endDateFormat - Description of how the end date should be formed
 *
 * @returns {Array<string>} Returns an array of formatted dates
 */
export interface DateRange {
  startDate: Date; // Adjust based on your actual date type
  endDate: Date; // Adjust based on your actual date type
}

export const getFormattedDatePeriods = (
  dateArray: DateRange[], // Specify the type of the array
  startDateFormat: string, // Use 'string' instead of 'any'
  endDateFormat: string, // Use 'string' instead of 'any'
): string[] => {
  // Specify the return type as 'string[]'
  const dateUtil = getDateUtilDefaultInstance();
  const newDateArray: string[] = []; // Initialize as string array

  dateArray.forEach(({startDate, endDate}) => {
    newDateArray.push(
      `${dateUtil.formatDate(
        startDate,
        startDateFormat,
      )} - ${dateUtil.formatDate(endDate, endDateFormat)}`,
    );
  });

  return newDateArray; // Return as string array
};
